/* global THREE */
import aframe from "aframe";
import { stringifyRotation } from "@micosmo/aframe/lib/utils";

// const utils = aframe.utils;
let poolEl;
let smartPoolEl;

const MissileTargets = new WeakMap();
let PlayerBuildings;

// Closest player building to position ignoring any in ignoreList
function closestTarget(position, ignoreList) {
  let closest = undefined;
  let closestDist = -1;
  for (const b of PlayerBuildings) {
    if (ignoreList && ignoreList.includes(b)) {
      continue;
    }
    const distance = position.distanceTo(b.object3D.position);
    if (closest === undefined || distance < closestDist) {
      closest = b;
      closestDist = distance;
    }
  }
  return closest;
}

function addTarget(missile, target) {
  if (!MissileTargets.has(missile)) {
    MissileTargets.set(missile, []);
  }
  MissileTargets.get(missile).push(target);
}

aframe.registerSystem("missile", {
  init: function () {
    this.gameEl = this.el.querySelector("#game-board");
    poolEl = document.querySelector("[mipool__missile]");
    smartPoolEl = document.querySelector("[mipool__smartMissile]");

    PlayerBuildings = Array.from(document.querySelectorAll(".city")).concat(
      Array.from(document.querySelectorAll(".missile-silo"))
    );
  },
  /*
  tick: function (t, dtm) {
    // const dt = dtm / 1000;
  },
  */
  spawn: function (data, position, rotation) {
    const pool = poolEl.components.mipool__missile;
    const missileEl = pool.requestEntity();
    if (missileEl === undefined) {
      console.warn("No more missiles in the pool.");
      return undefined;
    }

    if (position !== undefined) {
      missileEl.setAttribute("position", position);
    }
    if (rotation !== undefined) {
      missileEl.setAttribute("rotation", stringifyRotation(rotation));
    }
    missileEl.setAttribute("missile", data);
    missileEl.components.missile.reset();
    missileEl.play();

    MissileTargets.delete(missileEl);

    return missileEl;
  },
  spawnAndTarget: (() => {
    const v1 = new THREE.Vector3();
    const m1 = new THREE.Matrix4();

    return function (data, position, target) {
      const start = position;
      const end = v1.copy(target.object3D.position);
      const distance = start.distanceTo(end);
      const rotation = m1.lookAt(start, end, this.el.object3D.up);

      data.distance = distance;
      const missileEl = this.spawn(data, start, rotation);
      if (!missileEl) {
        return;
      }
      addTarget(missileEl, target);
      return missileEl;
    };
  })(),
  spawnSmartMissile: function (data, position, rotation) {
    const pool = smartPoolEl.components.mipool__smartmissile;
    const missileEl = pool.requestEntity();
    if (missileEl === undefined) {
      console.warn("No more smart missiles in the pool.");
      return undefined;
    }

    if (position !== undefined) {
      missileEl.setAttribute("position", position);
    }
    if (rotation !== undefined) {
      missileEl.setAttribute("rotation", stringifyRotation(rotation));
    }
    missileEl.setAttribute("smart-missile", data);
    missileEl.components["smart-missile"].reset();
    missileEl.play();

    return missileEl;
  },
  spawnSmartMissileAndTarget: (() => {
    const v1 = new THREE.Vector3();
    const m1 = new THREE.Matrix4();

    return function (data, position, target) {
      const start = position;
      const end = v1.copy(target.object3D.position);
      // const distance = start.distanceTo(end);
      const rotation = m1.lookAt(start, end, this.el.object3D.up);

      // smart-missile component does not have distance data item
      // data.distance = distance;
      const missileEl = this.spawnSmartMissile(data, start, rotation);
      return missileEl;
    };
  })(),
  split: function (missile, data) {
    // New missile should target a unit which hasnt been targetted by a previously split missile
    const prevTargets = MissileTargets.get(missile) || [];
    const nextTarget = closestTarget(missile.object3D.position, prevTargets);
    this.spawnAndTarget(data, missile.object3D.position, nextTarget);
    addTarget(missile, nextTarget);
  },
  release: function (missile) {
    if (missile.computedMixinStr === "missile") {
      missile.setAttribute("missile", {}, true); // Reset to defaults
      const pool = poolEl.components.mipool__missile;
      pool.returnEntity(missile);
    } else if (missile.computedMixinStr === "smart-missile") {
      missile.setAttribute("smart-missile", {}, true); // Reset to defaults
      const pool = smartPoolEl.components.mipool__smartmissile;
      pool.returnEntity(missile);
    } else {
      throw new Error(missile);
    }
  }
});

export { closestTarget };
